
import React from "react";
import { Button } from "@/components/ui/button";
import { Wand2 } from "lucide-react";
import { ThemeClasses } from "./CraftGeneratorTheme";

interface GeneratorActionsProps {
  onGenerateIdeas: () => void;
  onReset: () => void;
  hasSelectedSupplies: boolean;
  themeClasses: ThemeClasses;
}

const GeneratorActions: React.FC<GeneratorActionsProps> = ({ 
  onGenerateIdeas, 
  onReset, 
  hasSelectedSupplies,
  themeClasses 
}) => {
  return (
    <div className="flex justify-between gap-4">
      <Button
        onClick={onGenerateIdeas}
        className={`${themeClasses.buttonClass} flex-1`}
        disabled={!hasSelectedSupplies}
      >
        <Wand2 className="mr-2 h-4 w-4" /> Generate Craft Ideas
      </Button>
      <Button
        onClick={onReset}
        className={`${themeClasses.resetClass}`}
        variant="outline"
      >
        Reset
      </Button>
    </div>
  );
};

export default GeneratorActions;
